//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscPie(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.0001 2C6.11007 2 1.46007 7.1 2.05007 13H9.86007L6.14007 17.43C5.49007 16.72 4.96007 15.9 4.59007 15H2.46007C3.74007 19.05 7.53007 22 12.0001 22C17.5101 22 22.0001 17.51 22.0001 12C22.0001 6.49 17.5101 2 12.0001 2ZM4.07007 11C4.56007 7.06 7.93007 4 12.0001 4C13.6001 4 15.0801 4.48 16.3301 5.28L11.5301 11H4.07007ZM12.0001 20C10.4001 20 8.92007 19.52 7.67007 18.72L17.8601 6.57C19.1801 8 20.0001 9.9 20.0001 12C20.0001 16.41 16.4101 20 12.0001 20Z" fill="currentColor" /></svg>;
}
export default IconMiscPie;